export const MOBILE_WIDTH = 600;
export const TABLET_WIDTH = 960;
